import { createSelector } from "reselect"
import { get, chain, map } from "lodash"
import { getCurrent } from "./forecast"
import { getFactorCategoryId } from "."

export const FACTORS = {
  expectedReturn: {
    category: "dailyForecast",
    label: "Forecast Return",
  },
}

export const getForecastId = (_, props) => props.forecastId

function getFactorLabel(factors, id) {
  const factor = get(factors, id, { label: id })
  return factor.overviewLabel || factor.label
}

function getFactorCategory(factors, id) {
  return get(factors, [id, "category"])
}

export const getAllItems = createSelector(
  [getCurrent],
  (lastDatum) => map(FACTORS, (_, id) => ({
    id,
    label: getFactorLabel(FACTORS, id),
    category: getFactorCategory(FACTORS, id),
    lastValue: get(lastDatum, ["factors", id], 0),
    field: `factors.${id}`,
    disabled: false,
  })),
)

export const getAllCategoryItems = createSelector(
  [getAllItems, getFactorCategoryId],
  (items, displayType) => chain(items)
    .filter(item => item.category === displayType)
    .orderBy(item => Math.abs(item.lastValue), ["desc"])
    .value(),

)

export const getOrderedCategoryItems = createSelector(
  [getAllItems, getFactorCategoryId],
  (items, displayType) => chain(items)
    .filter(item => item.category === displayType)
    .orderBy(item => Math.abs(item.lastValue), ["asc", "desc"])
    .value(),
)
